export default __webpack_public_path__ + "static/media/no_search.4eb6b0be.svg";